import React from "react";
import { Modal, Button, Typography, Row, Col } from "antd";
import { SoundOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { useModalDismissal } from "components/shared-components/PreferenciasModais";

const { Title, Paragraph, Text } = Typography;

const NOVO_GRUPO_LINK = "https://chat.whatsapp.com/HtSuSe0ids6Lk59yVPy9uH";
const QR_CODE_URL = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(
	NOVO_GRUPO_LINK,
)}`;

/**
 * Aviso de migração do grupo da comunidade: perdemos o acesso ao número que
 * administrava os grupos; o grupo antigo não será mais gerenciado. Visual de
 * urgência (banner vermelho→laranja + megafone), DIFERENTE do modal verde de
 * convite antigo, pra chamar atenção. Entrada por QR ou botão (como o antigo).
 * Dismissal server-side (chave comunidade_novo_grupo, política snooze de 48h).
 */
const ComunidadeNovoGrupoModal = () => {
	const { deveExibir, dispensar } = useModalDismissal("comunidade_novo_grupo");

	const entrarNoGrupo = () => {
		window.open(NOVO_GRUPO_LINK, "_blank");
		dispensar("cta");
	};
	const jaEntrei = () => dispensar("ja_membro");
	const lembrarDepois = () => dispensar("snooze");
	const naoInteresse = () => dispensar("nao_interesse");

	return (
		<Modal
			open={deveExibir}
			onCancel={lembrarDepois}
			footer={null}
			width={560}
			centered
			bodyStyle={{ padding: 0, borderRadius: 14, overflow: "hidden" }}
			style={{ borderRadius: 14 }}
		>
			{/* banner de urgência — visual distinto do modal verde da comunidade */}
			<div
				style={{
					background:
						"linear-gradient(135deg, #cf1322 0%, #fa8c16 100%)",
					padding: "26px 24px 22px",
					textAlign: "center",
					color: "#fff",
				}}
			>
				<SoundOutlined style={{ fontSize: 40, marginBottom: 8 }} />
				<div
					style={{
						fontSize: 13,
						letterSpacing: 1.5,
						textTransform: "uppercase",
						opacity: 0.95,
						fontWeight: 600,
					}}
				>
					Aviso importante
				</div>
				<Title
					level={3}
					style={{
						color: "#fff",
						margin: "6px 0 0",
						fontWeight: 800,
						lineHeight: 1.3,
					}}
				>
					Mudamos o grupo da comunidade
				</Title>
			</div>

			<div style={{ padding: "22px 26px 24px" }}>
				<Paragraph style={{ fontSize: 15, marginBottom: 12 }}>
					Perdemos o acesso ao número de WhatsApp que administrava os
					grupos da comunidade, e o{" "}
					<strong>grupo antigo não será mais gerenciado</strong>.
				</Paragraph>
				<Paragraph style={{ fontSize: 15, marginBottom: 18 }}>
					Para continuar recebendo novidades e participando, entre no
					nosso <strong>novo grupo oficial</strong>:
				</Paragraph>

				{/* entrada por QR Code ou botão — mesmo formato do modal antigo */}
				<Row gutter={[20, 20]} justify="center" align="middle">
					<Col xs={24} sm={12} style={{ textAlign: "center" }}>
						<div
							style={{
								padding: 16,
								border: "1px solid #d9d9d9",
								borderRadius: 8,
								height: "100%",
							}}
						>
							<Text
								strong
								style={{ display: "block", marginBottom: 12 }}
							>
								Escaneie o QR Code
							</Text>
							<img
								src={QR_CODE_URL}
								alt="QR Code do novo grupo no WhatsApp"
								style={{
									width: 170,
									height: 170,
									margin: "0 auto",
									display: "block",
								}}
							/>
						</div>
					</Col>
					<Col xs={24} sm={12} style={{ textAlign: "center" }}>
						<div
							style={{
								padding: 16,
								border: "1px solid #d9d9d9",
								borderRadius: 8,
								height: "100%",
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Text
								strong
								style={{ display: "block", marginBottom: 12 }}
							>
								Ou clique no botão
							</Text>
							<Button
								type="primary"
								size="large"
								icon={<WhatsAppOutlined />}
								onClick={entrarNoGrupo}
								style={{
									background: "#25D366",
									borderColor: "#25D366",
									height: 48,
									fontSize: 15,
									fontWeight: 700,
								}}
							>
								Entrar no novo grupo
							</Button>
						</div>
					</Col>
				</Row>

				<div
					style={{
						display: "flex",
						gap: 10,
						flexWrap: "wrap",
						marginTop: 20,
					}}
				>
					<Button onClick={jaEntrei} style={{ flex: 1, minWidth: 180 }}>
						Já faço parte do novo grupo
					</Button>
					<Button
						onClick={lembrarDepois}
						style={{ flex: 1, minWidth: 140 }}
					>
						Lembrar depois
					</Button>
				</div>
				<Button
					type="text"
					danger
					block
					onClick={naoInteresse}
					style={{ marginTop: 8 }}
				>
					Não tenho interesse
				</Button>
			</div>
		</Modal>
	);
};

export default ComunidadeNovoGrupoModal;
